import { environment } from 'src/environments/environment';

async function resolveBrandedPortalKey(): Promise<string | null> {
	try {
		const response = await fetch(`${environment.baseAPIUrl}/branded-portal-key`, {
			method: 'GET',
			headers: { Accept: 'application/json' },
			signal: AbortSignal.timeout(5000),
		});
		if (!response.ok) {
			return null;
		}

		const body = await response.json();
		const apiKey = body?.message?.apiKey;
		return typeof apiKey === 'string' && apiKey ? apiKey : null;
	} catch {
		return null;
	}
}

/** Loads the portal key for this origin before the app makes authenticated calls. */
export function loadBrandedPortalKey(): Promise<void> {
	const origin = window.location.origin;
	environment.baseAPIUrl = environment.apiUrls[origin] || environment.baseAPIUrl;
	environment.baseUrl = environment.apiUrls[origin] || environment.baseUrl;

	return resolveBrandedPortalKey().then(apiKey => {
		if (!apiKey) {
			console.warn('Branded portal key lookup did not return a key.');
			return;
		}

		environment.apiKey = apiKey;
	});
}
